/** `'0'` = Normal Agent, `'1'` = Call Center Agent. */
export type AgentType = '0' | '1';

export const AGENT_TYPE_LABEL: Record<AgentType, string> = {
  '0': 'Normal Agent',
  '1': 'Call Center Agent',
};

export interface AgentRow {
  agentNumber: string;
  agentName: string;
  agentType: AgentType;
}

export interface AgentGroupRow {
  groupId: number;
  groupName: string;
  /** Legacy typo preserved on the wire — also written `requestDate` in some places. */
  reqestDate?: string;
  requestDate?: string;
}

export interface AgentGroupDetail {
  groupId: number;
  groupName: string;
  agents: AgentRow[];
}

export interface CreateAgentGroupRequest {
  userId: number;
  groupName: string;
  agents: AgentRow[];
}

export interface UpdateAgentGroupRequest extends CreateAgentGroupRequest {
  groupId: number;
}
